import React from "react";
import { Link, useMatches, useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, Button, Card, Space } from "antd";

import routes from "../../../engine/routes";
import { HomeOutlined } from "@ant-design/icons";
import { IoArrowBackCircle, IoChevronForward } from "react-icons/io5";
import { useSelector } from "react-redux";
import { initInstitutionSlice } from "../../../pages/Institutions/Slices/Institution.slice";
import { renderUserName } from "../../../utils/constants";
import useDeviceDetect from "../../../engine/hooks/useDeviceDetect";
import { initPrincipalSlice } from "../../../pages/Principals/Slices/Principal.slice";
import { RenderTitle } from "../../../engine/AuthRoute/navigationHelper";

export const PrestationCrumb = ({ route }) => {
  const { id } = useParams();

  const { prestation, loading } = useSelector(state => state.prestation);

  if (loading) {
    return <span className={"loadingdots"}>...</span>;
  }

  let title = `  ${prestation.reference} - ${prestation.institution?.name ||
    ""}`;

  return (
    <BreadcrumbsLink
      to={route.pathname}
      title={id === "new" ? routes.prestations().new.title : title}
    />
  );
};

export const InstitutionCrumb = ({ route }) => {
  const { id } = useParams();

  const { institution, loading } = useSelector(state => state.institution);

  const { init, clear } = initInstitutionSlice({ id: route.params.id });

  if (loading) {
    return <span className={"loadingdots"}>...</span>;
  }

  let title = `${institution?.name || ""} `;

  return (
    <BreadcrumbsLink
      to={route.pathname}
      title={id === "new" ? routes.institutions().new.title : title}
    />
  );
};

export const PrincipalCrumb = ({ route }) => {
  const { id } = useParams();

  const { principal, loading } = useSelector(state => state.principal);

  const { init, clear } = initPrincipalSlice({ id: route.params.id });

  if (loading) {
    return <span className={"loadingdots"}>...</span>;
  }

  let title = `${principal?.name || ""} `;

  return (
    <BreadcrumbsLink
      to={route.pathname}
      title={id === "new" ? routes.principals().new.title : title}
    />
  );
};

export const BreadcrumbsLink = ({ to = "/", title }) => {
  return (
    <Link to={to}>
      <RenderTitle title={title} trim={40} />
    </Link>
  );
};

export const InstitutionUserCrumb = ({ route }) => {
  const { user: userId, id } = useParams();

  const { institution, loading } = useSelector(state => state.institution);
  const { loading: LoadingUser, user } = useSelector(state => state.user);

  const { init, clear } = initInstitutionSlice({ id });

  if (loading || LoadingUser) {
    return <span className={"loadingdots"}>...</span>;
  }

  return (
    <BreadcrumbsLink
      to={route.pathname}
      title={
        userId !== "new"
          ? `${renderUserName(user)} `
          : routes.institutions().newUserInstitution().title
      }
    />
  );
};

export const InterpretesCrumb = ({ route }) => {
  const { id } = useParams();

  const { interprete, loading } = useSelector(state => state.interprete);

  if (loading) {
    return <span className={"loadingdots"}>...</span>;
  }

  let title = `${renderUserName(interprete)} `;

  return (
    <BreadcrumbsLink
      to={route.pathname}
      title={id === "new" ? routes.interpretes().new.title : title}
    />
  );
};

export const UsersCrumb = ({ route }) => {
  const { id } = useParams();

  const { user, loading } = useSelector(state => state.userControl);

  if (loading) {
    return <span className={"loadingdots"}>...</span>;
  }

  let title = `${renderUserName(user)} `;

  return (
      <BreadcrumbsLink
          to={route.pathname}
          title={id === "new" ? routes.users().new.title : title}
      />
  );
};

export const BillingCrumb = ({ route }) => {
  const { id } = useParams();

  const { bill, loading } = useSelector(state => state.bill);

  if (loading) {
    return <span className={"loadingdots"}>...</span>;
  }


  let title = `${bill.bill_number}`;

  return (
    <BreadcrumbsLink
      to={route.pathname}
      title={id === "new" ? routes.billing().detail.title : title}
    />
  );
};

export const Breadcrumbs = () => {
  const navigate = useNavigate();

  const { isMobile } = useDeviceDetect();

  const { isMobile: isMobile980 } = useDeviceDetect(980);

  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };

  let matches = useMatches();
  let crumbs = matches
    .filter(match => Boolean(match.handle?.crumb))
    .map(match => match.handle.crumb(match));

  const itemsMatches = crumbs.map(crum => {
    return {
      title: <RenderTitle title={crum} />,
    };
  });

  const items = [
    {
      title: (
        <BreadcrumbsLink
          to={routes.root().path}
          title={
            <>
              <HomeOutlined />
              <span
                style={{
                  marginLeft: 5,
                  display: "inline-block",
                  paddingTop: 0,
                }}
              >
                {routes.root().title}
              </span>
            </>
          }
        />
      ),
    },
    ...itemsMatches,
  ];

  return isMobile ? null : (
    <div
      style={{
        backgroundColor: "#f8f8f8",
        marginTop: 59,
        position: "fixed",
        marginLeft: isMobile980 ? -8 : 2,
        zIndex: 1000,
        width: "100%",
        paddingTop: 2,
      }}
    >
      <nav aria-label="Breadcrumb" style={{}}>
        <Card bodyStyle={{ padding: 5 }}>
          <Space direction={"horizontal"}>
            <Button onClick={handleGoBack} type={"text"} danger>
              <IoArrowBackCircle
                style={{ marginTop: -3, marginRight: 2 }}
                size={20}
              />
              Retour
            </Button>
            <Breadcrumb
              items={items}
              separator={<IoChevronForward size={16} />}
            />
          </Space>
        </Card>
      </nav>
    </div>
  );
};
